import React from "react";

interface PricingTierProps {
  label: string;
  type: string;
  price: string;
  per: string;
  badge?: string;
  save?: string;
  isFeatured?: boolean;
}

const PricingTier: React.FC<PricingTierProps> = ({
  label,
  type,
  price,
  per,
  badge,
  save,
  isFeatured = false,
}) => (
  <div
    className={`relative flex flex-col items-center rounded-[1.125rem] px-6 pb-8 text-center transition-transform duration-300 hover:-translate-y-1 ${
      isFeatured
        ? "border-2 border-primary bg-gradient-to-b from-gold/20 to-cream to-65% pt-10 shadow-lg dark:to-slate-700"
        : "border border-gray-200 bg-cream pt-8 dark:border-slate-600 dark:bg-slate-700"
    }`}
  >
    {badge && (
      <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-primary px-4 py-1.5 text-xs font-extrabold uppercase tracking-widest text-white shadow-lg">
        {badge}
      </div>
    )}

    <div className="text-[0.66rem] font-semibold uppercase tracking-[0.16em] text-gray-500 dark:text-gray-400">
      {label}
    </div>
    <div className="my-2 text-base font-extrabold tracking-tight text-primary dark:text-primary-light">
      {type}
    </div>
    <div className="text-4xl font-extrabold leading-none tracking-tight text-gray-900 dark:text-white md:text-5xl">
      {price}
    </div>
    <div className="mt-2.5 text-sm font-medium tracking-wide text-gray-500 dark:text-gray-400">
      {per}
    </div>
    {save && (
      <div className="mt-3.5 text-sm font-bold italic text-primary dark:text-primary-light">
        {save}
      </div>
    )}
  </div>
);

export default PricingTier;
